import {
    toLakh,
    sumThis,
    numberWithCommas,
    toCurrency,
    sumOf,
    countOf,
    sumAndCountOf,
    showSum,
    showCount,
    showSumAndCount,
    percentChange,
    showBlank,
    changeClassTo,
    mobileNumber,
    allDates
  } from "../commonFunctions";
  
  const nonvoter = {
    label: "Non Voter",
    starting: true,
    url: "nonvoter",
    pageLabel: "Non Voter",
    pageType: "history",
    formTabs: {
      allTabs: [
        { label: "Profile", uid: "profile", style: { fontFamily: "verdana" } },
        { label: "Timeline", uid: "timeline", style: { fontFamily: "verdana" } },
        { label: "Office Visit", uid: "officevisit", style: { fontFamily: "verdana" } },
        { label: "Complaints", uid: "complaints", style: { fontFamily: "verdana" }},
        { label: "Outward", uid: "outward", style: { fontFamily: "verdana" } },
        { label: "Event", uid: "event", style: { fontFamily: "verdana" } },
        { label: "Relations", uid: "relations", style: { fontFamily: "verdana" } },
        { label: "Family", uid: "family", style: { fontFamily: "verdana" } },
      ]
    },
    form: [
      {
        widths: "col-lg-12",
        tab:"profile",
        subComponents: [
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-lg-12",
              children: "col-lg-12"
            },
            label: "Profile Information",
          },
      {
        inputType: "displaytext",
        
        widths: {
          parent: "col-lg-2",
          children: "col-lg-12"
        },
        label: "First Name",
        description: "Enter First Name"
      },
      {
        inputType: "text",
        
        widths: {
          parent: "col-lg-2",
          children: "col-lg-12"
        },
        placeHolder: "First Name",
        name: "firstName",
        description: "Enter First Name"
      },
      {
        inputType: "displaytext",
        
        widths: {
          parent: "col-lg-2",
          children: "col-lg-12"
        },
        label: "Middle Name",
        description: "Enter Middle Name"
      },
      {
        inputType: "text",
        
        widths: {
          parent: "col-lg-2",
          children: "col-lg-12"
        },
        placeHolder: "Middle Name",
        name: "middleName",
        description: "Enter Middle Name"
      },
      {
        inputType: "displaytext",
        
        widths: {
          parent: "col-lg-2",
          children: "col-lg-12"
        },
        label: "Last Name",
        description: "Enter Last Name"
      },
      {
        inputType: "text",
        
        widths: {
          parent: "col-lg-2",
          children: "col-lg-12"
        },
        placeHolder: "Last Name",
        name: "lastName",
        description: "Enter Last Name"
      },
      {
        inputType: "radio",
        // default:"finish",
        widths: {
          parent: "col-lg-4",
          children: "col-lg-6"
        },
        options: [
          { label: "Male", value: "male" },
          { label: "Female", value: "female" },
        ],
        propType: "string",
        //  label:"Gender",
        name: "gender",
        description: ""
      },
      
      {
        inputType: "displaytext",
        
        widths: {
          parent: "col-lg-2",
          children: "col-lg-12"
        },
        label: "Voter ID",
        description: "Enter Voter ID"
      },
      {
        inputType: "text",
        
        widths: {
          parent: "col-lg-2",
          children: "col-lg-12"
        },
        placeHolder: "Voter ID",
        name: "VoterID",
        description: "Enter Voter ID"
      }, 
      {
        inputType: "displaytext",
        
        widths: {
          parent: "col-lg-2",
          children: "col-lg-12"
        },
        label: "Region",
        description: "Enter Region"
      }, 
      {
        inputType: "text",
        
        widths: {
          parent: "col-lg-2",
          children: "col-lg-12"
        },
        placeHolder: "Region",
        name: "region",
        description: "Enter Region"
      }, 
      {
        inputType: "displaytext",
        
        widths: {
          parent: "col-lg-2",
          children: "col-lg-12"
        },
        label: "Circle",
        description: "Enter Circle"
      }, 
      {
        inputType: "text",
        
        widths: {
          parent: "col-lg-2",
          children: "col-lg-12"
        },
        placeHolder: "Circle",
        name: "circle",
        description: "Enter Circle"
      }, 
      {
        inputType: "displaytext",
        
        widths: {
          parent: "col-lg-2",
          children: "col-lg-12"
        },
        label: "Sub Circle",
        description: "Enter Sub Circle"
      }, 
      {
        inputType: "text",
        
        widths: {
          parent: "col-lg-2",
          children: "col-lg-12"
        },
        placeHolder: "Sub Circle",
        name: "subcircle",
        description: "Enter Sub Circle"
      }, 
      {
        inputType: "displaytext",
        
        widths: {
          parent: "col-lg-2",
          children: "col-lg-12"
        },
        label: "Booth",
        description: "Enter Booth"
      }, 
      {
        inputType: "text",
        
        widths: {
          parent: "col-lg-2",
          children: "col-lg-12"
        },
        placeHolder: "Booth",
        name: "booth",
        description: "Enter Booth"
      }, 
      
      {
        inputType: "displaytext",
        
        widths: {
          parent: "col-lg-2",
          children: "col-lg-12"
        },
        label: "Village",
        description: "Enter Village"
      }, 
      {
        inputType: "text",
        
        widths: {
          parent: "col-lg-2",
          children: "col-lg-12"
        },
        placeHolder: "Village",
        name: "village",
        description: "Enter Village"
      }, 
      {
        inputType: "displaytext",
        
        widths: {
          parent: "col-lg-2",
          children: "col-lg-12"
        },
        label: "Age",
        description: "Enter Age"
      },
      {
          inputType: "showdata",
          
          data: "branch",
          textcolor: "black",
          widths: {
            parent: "col-lg-2",
            children: "col-lg-12"
         },
      },
      {
        inputType: "displaytext",
        
        widths: {
          parent: "col-lg-2",
          children: "col-lg-12"
        },
        label: "Voter Profile",
        description: "Enter Profile"
      },
      {
        inputType: "select",
        
        default: "voter",
        widths: {
          parent: "col-lg-2",
          children: "col-lg-12"
        },
        options: [
          {
            label: "Voter",
            value: "voter"
          },
          {
            label: "Booth Incharge",
            value: "boothincharge"
          },
          
          {
            label: "E-Volunteer",
            value: "evolunteer"
          },
          {
            label: "P-Volunteer",
            value: "pvolunteer"
          },
        ],
        placeHolder: "Voter Profile",
        name: "voterprofile",
        description: "Enter Voter Profile"
      },
      {
        inputType: "displaytext",
        
        widths: {
          parent: "col-lg-2",
          children: "col-lg-12"
        },
        label: "Address",
        description: "Enter Address"
      }, 
      {
        inputType: "text",
        
        widths: {
          parent: "col-lg-4",
          children: "col-lg-12"
        },
        placeHolder: "Address",
        name: "address",
        description: "Enter Address"
      },
      
      
     ],
     },



     {
      widths: "col-lg-12",
      tab:"profile",
      subComponents: [
        {
          inputType: "displaytext",
          
          widths: {
            parent: "col-lg-12",
            children: "col-lg-12"
          },
          label: "Address Information",
        }, 
      
      {
        inputType: "displaytext",
        
        widths: {
          parent: "col-lg-2",
          children: "col-lg-12"
        },
        label: "Apartment Name",
        description: "Enter Apartment Name"
      },
      {
        inputType: "text",
        
        widths: {
          parent: "col-lg-4",
          children: "col-lg-12"
        },
        placeHolder: "Apartment Name",
        name: "apartmentName",
        description: "Enter Apartment Name"
      },
      {
        inputType: "displaytext",
        
        widths: {
          parent: "col-lg-2",
          children: "col-lg-12"
        },
        label: "House Number",
        description: "Enter House Number"
      },
      {
        inputType: "text",
        
        widths: {
          parent: "col-lg-4",
          children: "col-lg-12"
        },
        placeHolder: "House Number",
        name: "housenumber",
        description: "Enter House Number"
      },
      {
        inputType: "displaytext",
        
        widths: {
          parent: "col-lg-2",
          children: "col-lg-12"
        },
        label: "Zip Code",
        description: "Enter Zip Code"
      },
      {
        inputType: "numberonly",
        
        widths: {
          parent: "col-lg-4",
          children: "col-lg-12"
        },
        placeHolder: "Zip Code",
        name: "zipCode",
        description: "Enter Zip Code"
      },
      {
        inputType: "displaytext",
        
        widths: {
          parent: "col-lg-2",
          children: "col-lg-12"
        },
        label: "Mobile Number1",
        description: "Enter Mobile Number1"
      },
      {
        inputType: "numberonly",
        
        widths: {
          parent: "col-lg-4",
          children: "col-lg-12"
        },
        placeHolder: "Mobile Number1",
        name: "mobilenumber1",
        description: "Enter Mobile Number1"
      },
      {
        inputType: "displaytext",
        
        widths: {
          parent: "col-lg-2",
          children: "col-lg-12"
        },
        label: "Mobile Number2",
        description: "Enter Mobile Number2"
      },
      {
        inputType: "numberonly",
        
        widths: {
          parent: "col-lg-4",
          children: "col-lg-12"
        },
        placeHolder: "Mobile Number2",
        name: "mobilenumber2",
        description: "Enter Mobile Number2"
      },
      {
        inputType: "displaytext",
        
        widths: {
          parent: "col-lg-2",
          children: "col-lg-12"
        },
        label: "Landline",
        description: "Enter Landline"
      },
      {
        inputType: "numberonly",
        
        widths: {
          parent: "col-lg-4",
          children: "col-lg-12"
        },
        placeHolder: "Landline",
        name: "landline",
        description: "Enter Landline"
      },
     
      {
        inputType: "displaytext",
        
        widths: {
          parent: "col-lg-2",
          children: "col-lg-12"
        },
        label: "Date of Birth",
        description: "Enter Date of Birth"
      },
      {
          inputType: "date",
          dateType: "ontype",
          
          isRequired: true,
          widths: {
            parent: "col-lg-4",
            children: "col-lg-12"
          },
          placeHolder: "DOB",
          displayFormat: "DD/MM/YYYY",
          outputFormat: "YYYYMMDD",
          name: "dob",
          description: "Enter DOB"
      },
      
      ],
      },

      {
        widths: "col-lg-12",
        tab:"profile",
        subComponents: [
          
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-lg-12",
              children: "col-lg-12"
            },
            label: "Social Networks",
          },
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-lg-2",
              children: "col-lg-12"
            },
            label: "Email",
            description: "Enter Email"
          },
          {
            inputType: "text",
            
            widths: {
              parent: "col-lg-4",
              children: "col-lg-12"
            },
            placeHolder: "Email",
            name: "email",
            description: "Enter Email"
          },
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-lg-2",
              children: "col-lg-12"
            },
            label: "Facebook",
            description: "Enter Facebook"
          },
          {
            inputType: "text",
            
            widths: {
              parent: "col-lg-4",
              children: "col-lg-12"
            },
            placeHolder: "Facebook",
            name: "facebook",
            description: "Enter Facebook"
          },
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-lg-2",
              children: "col-lg-12"
            },
            label: "Twitter",
            description: "Enter Twitter"
          },
          {
            inputType: "text",
            
            widths: {
              parent: "col-lg-4",
              children: "col-lg-12"
            },
            placeHolder: "Twitter",
            name: "twitter",
            description: "Enter Twitter"
          },
          
       
        {
          inputType: "displaytext",
          
          widths: {
            parent: "col-lg-2",
            children: "col-lg-12"
          },
          label: "Department",
          description: "Enter Department"
        }, 
        {
          inputType: "autocomplete",
          isRequired: true,
          
          default: "",
          elementProps: {
            stayOpen: false,
            removeSelected: true,
            disabled: false,
            rtl: false
          },
          widths: {
            parent: "col-lg-4",
            children: "col-lg-12"
          },
          options: [],
          ajaxLoad: true,
          ajaxOptions: {
            query: {
              dialect: "mongodb",
              query: "getDepartmentEle",
              fieldType: "string",
              filters: ["pageData", "departmentEle"]
            },
            label: "display",
            value: "display"
          },
           placeHolder: "Department",
          name: "Department",
          description: "Enter Department"
        },
        {
          inputType: "displaytext",
          
          widths: {
            parent: "col-lg-2",
            children: "col-lg-12"
          },
          label: "Sub Department",
          description: "Enter Sub Department"
        }, 
        {
          inputType: "autocomplete",
          isRequired: true,
          
          default: "",
          elementProps: {
            stayOpen: false,
            removeSelected: true,
            disabled: false,
            rtl: false
          },
          widths: {
            parent: "col-lg-4",
            children: "col-lg-12"
          },
          options: [],
          ajaxLoad: true,
          ajaxOptions: {
            query: {
              dialect: "mongodb",
              query: "getSubDepartmentEle",
              fieldType: "string",
              filters: ["pageData", "SubDepartmentEle"]
            },
            label: "display",
            value: "display"
          },
           placeHolder: "Sub Department",
          name: "subDepartment",
          description: "Enter Sub Department"
        },
        {
          inputType: "displaytext",
          
          widths: {
            parent: "col-lg-2",
            children: "col-lg-12"
          },
          label: "Designation",
          description: "Enter Designation"
        }, 
        {
          inputType: "autocomplete",
          isRequired: true,
          
          default: "",
          elementProps: {
            stayOpen: false,
            removeSelected: true,
            disabled: false,
            rtl: false
          },
          widths: {
            parent: "col-lg-4",
            children: "col-lg-12"
          },
          options: [],
          ajaxLoad: true,
          ajaxOptions: {
            query: {
              dialect: "mongodb",
              query: "getDesignationEle",
              fieldType: "string",
              filters: ["pageData", "DesignationEle"]
            },
            label: "display",
            value: "display"
          },
           placeHolder: "Designation",
          name: "designation",
          description: "Enter Designation"
        },
        
        ],
        },

        {
          widths: "col-lg-12",
          tab:"profile",
          subComponents: [
            {
              inputType: "displaytext",
              
              widths: {
                parent: "col-lg-12",
                children: "col-lg-12"
              },
              label: "Education Networks",
            },
            {
              inputType: "displaytext",
              
              widths: {
                parent: "col-lg-2",
                children: "col-lg-12"
              },
              label: "Education",
              description: "Enter Education"
            },
            {
              inputType: "autocomplete",
              isRequired: true,
              
              default: "",
              elementProps: {
                stayOpen: false,
                removeSelected: true,
                disabled: false,
                rtl: false
              },
              widths: {
                parent: "col-lg-4",
                children: "col-lg-12"
              },
              options: [],
              ajaxLoad: true,
              ajaxOptions: {
                query: {
                  dialect: "mongodb",
                  query: "getEducationEle",
                  fieldType: "string",
                  filters: ["pageData", "EducationEle"]
                },
                label: "display",
                value: "display"
              },
               placeHolder: "Education",
              name: "education",
              description: "Enter Education"
            },
            {
              inputType: "displaytext",
              
              widths: {
                parent: "col-lg-2",
                children: "col-lg-12"
              },
              label: "Occupation",
              description: "Enter Occupation"
            },
            {
              inputType: "autocomplete",
              isRequired: true,
              
              default: "",
              elementProps: {
                stayOpen: false,
                removeSelected: true,
                disabled: false,
                rtl: false
              },
              widths: {
                parent: "col-lg-4",
                children: "col-lg-12"
              },
              options: [],
              ajaxLoad: true,
              ajaxOptions: {
                query: {
                  dialect: "mongodb",
                  query: "getOccupationEle",
                  fieldType: "string",
                  filters: ["pageData", "OccupationEle"]
                },
                label: "display",
                value: "display"
              },
               placeHolder: "Occupation",
              name: "occupation",
              description: "Enter Occupation"
            },
            {
              inputType: "displaytext",
              
              widths: {
                parent: "col-lg-2",
                children: "col-lg-12"
              },
              label: "Blood Group",
              description: "Enter Blood Group"
            },
            {
              inputType: "autocomplete",
              isRequired: true,
              
              default: "",
              elementProps: {
                stayOpen: false,
                removeSelected: true,
                disabled: false,
                rtl: false
              },
              widths: {
                parent: "col-lg-4",
                children: "col-lg-12"
              },
              options: [],
              ajaxLoad: true,
              ajaxOptions: {
                query: {
                  dialect: "mongodb",
                  query: "getBloodGroup",
                  fieldType: "string",
                  filters: ["pageData", "BloodGroup"]
                },
                label: "display",
                value: "display"
              },
               placeHolder: "Blood Group",
              name: "bloodgroup",
              description: "Enter Blood Group"
            },
            {
              inputType: "displaytext",
              
              widths: {
                parent: "col-lg-2",
                children: "col-lg-12"
              },
              label: "Caste",
              description: "Enter Caste"
            },
            {
              inputType: "autocomplete",
              isRequired: true,
              
              default: "",
              elementProps: {
                stayOpen: false,
                removeSelected: true,
                disabled: false,
                rtl: false
              },
              widths: {
                parent: "col-lg-4",
                children: "col-lg-12"
              },
              options: [],
              ajaxLoad: true,
              ajaxOptions: {
                query: {
                  dialect: "mongodb",
                  query: "getCasteEle",
                  fieldType: "string",
                  filters: ["pageData", "CasteEle"]
                },
                label: "display",
                value: "display"
              },
               placeHolder: "Caste",
              name: "caste",
              description: "Enter Caste"
            },
            {
              inputType: "displaytext",
              
              widths: {
                parent: "col-lg-2",
                children: "col-lg-12"
              },
              label: "Party",
              description: "Enter Party"
            },
            {
              inputType: "autocomplete",
              isRequired: true,
              
              default: "",
              elementProps: {
                stayOpen: false,
                removeSelected: true,
                disabled: false,
                rtl: false
              },
              widths: {
                parent: "col-lg-4",
                children: "col-lg-12"
              },
              options: [],
              ajaxLoad: true,
              ajaxOptions: {
                query: {
                  dialect: "mongodb",
                  query: "getPartyEle",
                  fieldType: "string",
                  filters: ["pageData", "PartyEle"]
                },
                label: "display",
                value: "display"
              },
               placeHolder: "Party",
              name: "party",
              description: "Enter Party"
            },
            {
              inputType: "displaytext",
              
              widths: {
                parent: "col-lg-2",
                children: "col-lg-12"
              },
              label: "Candidate",
              description: "Enter Candidate"
            },
            {
              inputType: "autocomplete",
              isRequired: true,
              
              default: "",
              elementProps: {
                stayOpen: false,
                removeSelected: true,
                disabled: false,
                rtl: false
              },
              widths: {
                parent: "col-lg-4",
                children: "col-lg-12"
              },
              options: [],
              ajaxLoad: true,
              ajaxOptions: {
                query: {
                  dialect: "mongodb",
                  query: "getCandidateEle",
                  fieldType: "string",
                  filters: ["pageData", "CandidateEle"]
                },
                label: "display",
                value: "display"
              },
               placeHolder: "Candidate",
              name: "candidate",
              description: "Enter Candidate"
            },
            {
              inputType: "displaytext",
              
              widths: {
                parent: "col-lg-2",
                children: "col-lg-12"
              },
              label: "Voter Type",
              description: "Enter Voter Type"
            },
            {
                inputType: "select",
                
                default: "",
                widths: {
                  parent: "col-lg-4",
                  children: "col-lg-12"
                },
                options: [
                  {
                    label: "Positive",
                    value: "positive"
                  },
                  {
                    label: "Negative",
                    value: "negative"
                  },
                  {
                    label: "Known",
                    value: "known"
                  },
                  {
                    label: "Unknown",
                    value: "unknown"
                  },
                  {
                    label: "Doubtful",
                    value: "doubtful"
                  },
                  
                ],
                placeHolder: "Voter Type",
                name: "votertype",
                description: "Enter Voter Type"
            },
            
            {
                inputType: "checkbox",
                isRequired: true,
                default: "true",
                
                widths: {
                  parent: "col-lg-2",
                  children: "col-lg-12"
                },
                options:[
                 { name:"livingoutname",value:"livingout"}
                ],
                
                placeHolder: "Input",
                label: "Living Out Station",
                name: "livingoutstation",
                description: "Living Out Station"
            },
            {
              inputType: "displaytext",
              widths: {
                parent: "col-lg-2",
                children: "col-lg-12"
              },
              parents: [
                {
                  name: "livingoutstation",
                  match: "in",
                  value: ["livingout"]
                }
              ],
              label: "City",
              description: "Enter City"
            },
            {
              inputType: "autocomplete",
              isRequired: true,
              
              default: "",
              elementProps: {
                stayOpen: false,
                removeSelected: true,
                disabled: false,
                rtl: false
              },
              widths: {
                parent: "col-lg-4",
                children: "col-lg-12"
              },
              options: [],
              ajaxLoad: true,
              ajaxOptions: {
                query: {
                  dialect: "mongodb",
                  query: "getCityEle",
                  fieldType: "string",
                  filters: ["pageData", "CityEle"]
                },
                label: "display",
                value: "display"
              },
               placeHolder: "CityEle",
              name: "cityEle",
              description: "Enter CityEle"
            },
            {
              inputType: "checkbox",
              isRequired: true,
              default: "true",
              
              widths: {
                parent: "col-lg-2",
                children: "col-lg-12"
              },
              placeHolder: "Input",
              label: "Died Voter",
              name: "diedvoter",
              description: "Died Voter"
            },
            {
              inputType: "checkbox",
              isRequired: true,
              default: "true",
              
              widths: {
                parent: "col-lg-2",
                children: "col-lg-12"
              },
              placeHolder: "Input",
              label: "Duplicated Voter",
              name: "duplicatedVoter",
              description: "Duplicated Voter"
            },
            

                
          ],
          },





          {
            widths: "col-lg-12",
            tab:"timeline",
            subComponents: [
              {
                inputType: "displaytext",
                widths: {
                  parent: "col-lg-2",
                  children: "col-lg-12"
                },
                // label: "City",
                description: "Enter City"
              },

            ],
          },







          {
            widths: "col-lg-12",
            tab: "officevisit",
            subComponents: [
          {
                inputType: "displaytext",
                // 
                widths: {
                  parent: "col-lg-2",
                  children: "col-lg-12"
                },
                label: "Reason Type",
                description: "Enter Reason Type"
          },
          {
            inputType: "autocomplete",
            isRequired: true,
            
            default: "",
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-lg-4",
              children: "col-lg-12"
            },
            options: [],
            ajaxLoad: true,
            ajaxOptions: {
              query: {
                dialect: "mongodb",
                query: "getReasonEle",
                fieldType: "string",
                filters: ["pageData", "ReasonEle"]
              },
              label: "display",
              value: "display"
            },
             placeHolder: "Reason Type",
            name: "reasonType",
            description: "Enter Reason Type"
          },  
          {
            inputType: "displaytext",
            // 
            widths: {
              parent: "col-lg-2",
              children: "col-lg-12"
            },
            label: "Visit Date",
            description: "Enter Visit Date"
          },
          
          {
              inputType: "date",
              dateType: "ontype",
              
              isRequired: true,
              widths: {
                parent: "col-lg-3",
                children: "col-lg-12"
              },
              // default:allDates("today"),
              // placeHolder:"as",
              displayFormat: "DD/MM/YYYY",
              outputFormat: "YYYYMMDD",
              name: "visitDate",
              description: "Enter Visit Date"
          },





          {
            inputType: "displaytext",
            // 
            widths: {
              parent: "col-lg-2",
              children: "col-lg-12"
            },
            label: "Visit Reason",
            description: "Enter Visit Reason"
          },
          {
            inputType: "autocomplete",
            isRequired: true,

            default: "",
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-lg-9",
              children: "col-lg-12"
            },
            options: [],
            ajaxLoad: true,
            ajaxOptions: {
              query: {
                dialect: "mongodb",
                query: "getVisitReasonEle",
                fieldType: "string",
                filters: ["pageData", "VisitReasonEle"]
              },
              label: "display",
              value: "display"
            },
             placeHolder: "Visit Reason",
            name: "visitReason",
            description: "Enter Visit Reason"
          },   
          {
            inputType: "displaytext",
            // 
            widths: {
              parent: "col-lg-2",
              children: "col-lg-12"
            },
            label: "Remarks",
            description: "Enter Remarks"
          },   
          {
            inputType: "text",
            
            widths: {
              parent: "col-lg-9",
              children: "col-lg-12"
            },
            placeHolder: "Remarks",
            name: "remarks",
            description: "Enter Remarks"
          },
          {
            inputType: "displaytext",
            // 
            widths: {
              parent: "col-lg-2",
              children: "col-lg-12"
            },
            label: "Tags",
            description: "Enter Tags"
          },   
          {
            inputType: "text",
            
            widths: {
              parent: "col-lg-9",
              children: "col-lg-12"
            },
            placeHolder: "Tags",
            name: "tags",
            description: "Enter Tags"
          },     
          ],
          },




          {
            widths: "col-lg-12",
            tab:"complaints",
            subComponents: [
              {
                inputType: "displaytext",
                widths: {
                  parent: "col-lg-2",
                  children: "col-lg-12"
                },
                label: "Issue Type",
                description: "Enter Issue Type"
              },
              {
                inputType: "autocomplete",
                isRequired: true,
    
                default: "",
                elementProps: {
                  stayOpen: false,
                  removeSelected: true,
                  disabled: false,
                  rtl: false
                },
                widths: {
                  parent: "col-lg-4",
                  children: "col-lg-12"
                },
                options: [],
                ajaxLoad: true,
                ajaxOptions: {
                  query: {
                    dialect: "mongodb",
                    query: "getIssueTypeEle",
                    fieldType: "string",
                    filters: ["pageData", "IssueTypeEle"]
                  },
                  label: "display",
                  value: "display"
                },
                 placeHolder: "Issue Type",
                name: "issueType",
                description: "Enter Issue Type"
              },
              {
                inputType: "displaytext",
                // 
                widths: {
                  parent: "col-lg-2",
                  children: "col-lg-12"
                },
                label: "Date of Issue",
                description: "Enter Date of Issue"
              },
              {
                  inputType: "date",
                  dateType: "ontype",
                  
                  isRequired: true,
                  widths: {
                    parent: "col-lg-4",
                    children: "col-lg-12"
                  },
                  displayFormat: "DD/MM/YYYY",
                  outputFormat: "YYYYMMDD",
                  name: "dateofIssue",
                  description: "Enter Date of Issue"
              },
              {
                inputType: "displaytext",
                widths: {
                  parent: "col-lg-2",
                  children: "col-lg-12"
                },
                label: "Subject",
                description: "Enter Subject"
              },
              {
                inputType: "autocomplete",
                isRequired: true,
    
                default: "",
                elementProps: {
                  stayOpen: false,
                  removeSelected: true,
                  disabled: false,
                  rtl: false
                },
                widths: {
                  parent: "col-lg-4",
                  children: "col-lg-12"
                },
                options: [],
                ajaxLoad: true,
                ajaxOptions: {
                  query: {
                    dialect: "mongodb",
                    query: "getSubjectEle",
                    fieldType: "string",
                    filters: ["pageData", "SubjectEle"]
                  },
                  label: "display",
                  value: "display"
                },
                 placeHolder: "Subject",
                name: "subject",
                description: "Enter Subject"
              },
              {
                inputType: "displaytext",
                widths: {
                  parent: "col-lg-2",
                  children: "col-lg-12"
                },
                label: "Issue Status",
                description: "Enter Issue Status"
              },
              {
                inputType: "autocomplete",
                isRequired: true,
    
                default: "",
                elementProps: {
                  stayOpen: false,
                  removeSelected: true,
                  disabled: false,
                  rtl: false
                },
                widths: {
                  parent: "col-lg-4",
                  children: "col-lg-12"
                },
                options: [],
                ajaxLoad: true,
                ajaxOptions: {
                  query: {
                    dialect: "mongodb",
                    query: "getIssueStatusEle",
                    fieldType: "string",
                    filters: ["pageData", "IssueStatusEle"]
                  },
                  label: "display",
                  value: "display"
                },
                 placeHolder: "Issue Status",
                name: "issueStatus",
                description: "Enter Issue Status"
              },
              {
                inputType: "displaytext",
                widths: {
                  parent: "col-lg-2",
                  children: "col-lg-12"
                },
                label: "Priority",
                description: "Enter Priority"
              },
              {
                inputType: "autocomplete",
                isRequired: true,
    
                default: "",
                elementProps: {
                  stayOpen: false,
                  removeSelected: true,
                  disabled: false,
                  rtl: false
                },
                widths: {
                  parent: "col-lg-4",
                  children: "col-lg-12"
                },
                options: [],
                ajaxLoad: true,
                ajaxOptions: {
                  query: {
                    dialect: "mongodb",
                    query: "getPriorityEle",
                    fieldType: "string",
                    filters: ["pageData", "PriorityEle"]
                  },
                  label: "display",
                  value: "display"
                },
                 placeHolder: "Priority",
                name: "priority",
                description: "Enter Priority"
              },
              {
                inputType: "displaytext",
                widths: {
                  parent: "col-lg-2",
                  children: "col-lg-12"
                },
                label: "Reference",
                description: "Enter Reference"
              },
              {
                inputType: "autocomplete",
                isRequired: true,
    
                default: "",
                elementProps: {
                  stayOpen: false,
                  removeSelected: true,
                  disabled: false,
                  rtl: false
                },
                widths: {
                  parent: "col-lg-4",
                  children: "col-lg-12"
                },
                options: [],
                ajaxLoad: true,
                ajaxOptions: {
                  query: {
                    dialect: "mongodb",
                    query: "getReferenceEle",
                    fieldType: "string",
                    filters: ["pageData", "ReferenceEle"]
                  },
                  label: "display",
                  value: "display"
                },
                 placeHolder: "Reference",
                name: "reference",
                description: "Enter Reference"
              },
              {
                inputType: "displaytext",
                // 
                widths: {
                  parent: "col-lg-2",
                  children: "col-lg-12"
                },
                label: "Description",
                description: "Enter Description"
              },   
              {
                inputType: "text",
                
                widths: {
                  parent: "col-lg-4",
                  children: "col-lg-12"
                },
                placeHolder: "Description",
                name: "description",
                description: "Enter Description"
              }, 
              {
                inputType: "fileupload",
                widths: {
                  parent: "col-lg-6",
                  children: "col-lg-12"
                },
                label: "Attachment",
                name: "attachment",
                placeholder: {
                  type: "text",
                  value:
                    "Attachment"
                },
                files: [],
                multiple: true
                
              },
              {
                inputType: "displaytext",
                
                widths: {
                  parent: "col-lg-2",
                  children: "col-lg-12"
                },
                label: "Department",
                description: "Enter Department"
              }, 
              {
                inputType: "autocomplete",
                isRequired: true,
                
                default: "",
                elementProps: {
                  stayOpen: false,
                  removeSelected: true,
                  disabled: false,
                  rtl: false
                },
                widths: {
                  parent: "col-lg-4",
                  children: "col-lg-12"
                },
                options: [],
                ajaxLoad: true,
                ajaxOptions: {
                  query: {
                    dialect: "mongodb",
                    query: "getDepartmentEle",
                    fieldType: "string",
                    filters: ["pageData", "departmentEle"]
                  },
                  label: "display",
                  value: "display"
                },
                 placeHolder: "Department",
                name: "DepartmentComp",
                description: "Enter Department"
              },
              {
                inputType: "displaytext",
                
                widths: {
                  parent: "col-lg-2",
                  children: "col-lg-12"
                },
                label: "Responsible Officer",
                description: "Enter Responsible Officer"
              }, 
              {
                inputType: "autocomplete",
                isRequired: true,
                
                default: "",
                elementProps: {
                  stayOpen: false,
                  removeSelected: true,
                  disabled: false,
                  rtl: false
                },
                widths: {
                  parent: "col-lg-4",
                  children: "col-lg-12"
                },
                options: [],
                ajaxLoad: true,
                ajaxOptions: {
                  query: {
                    dialect: "mongodb",
                    query: "getResposibleOfficerEle",
                    fieldType: "string",
                    filters: ["pageData", "ResposibleOfficerEle"]
                  },
                  label: "display",
                  value: "display"
                },
                 placeHolder: "Responsible Officer",
                name: "ResponsibleOfficer",
                description: "Enter Responsible Officer"
              },
              {
                inputType: "displaytext",
                
                widths: {
                  parent: "col-lg-2",
                  children: "col-lg-12"
                },
                label: "Assisgned User",
                description: "Enter Assisgned User"
              }, 
              {
                inputType: "autocomplete",
                isRequired: true,
                
                default: "",
                elementProps: {
                  stayOpen: false,
                  removeSelected: true,
                  disabled: false,
                  rtl: false
                },
                widths: {
                  parent: "col-lg-4",
                  children: "col-lg-12"
                },
                options: [],
                ajaxLoad: true,
                ajaxOptions: {
                  query: {
                    dialect: "mongodb",
                    query: "getAssisgnedUserEle",
                    fieldType: "string",
                    filters: ["pageData", "AssisgnedUserEle"]
                  },
                  label: "display",
                  value: "display"
                },
                 placeHolder: "Assisgned User",
                name: "AssisgnedUser",
                description: "Enter Assisgned User"
              },
              {
                inputType: "displaytext",
                
                widths: {
                  parent: "col-lg-2",
                  children: "col-lg-12"
                },
                label: "Issue Number",
                description: "Enter Issue Number"
              },
              {
                inputType: "numberonly",
                
                widths: {
                  parent: "col-lg-4",
                  children: "col-lg-12"
                },
                placeHolder: "Issue Number",
                name: "issueNumber",
                description: "Enter Issue Number"
              },
              {
                inputType: "displaytext",
                // 
                widths: {
                  parent: "col-lg-2",
                  children: "col-lg-12"
                },
                label: "Issue Remarks",
                description: "Enter Issue Remarks"
              },   
              {
                inputType: "text",
                
                widths: {
                  parent: "col-lg-4",
                  children: "col-lg-12"
                },
                placeHolder: "Issue Remarks",
                name: "issueremarks",
                description: "Enter Issue Remarks"
              },
              {
                inputType: "checkbox",
                isRequired: true,
                default: "true",
                
                widths: {
                  parent: "col-lg-2",
                  children: "col-lg-12"
                },
                placeHolder: "Input",
                label: "Take Action",
                name: "takeActiona",
                description: "Take Action"
              },
              

            ],
          },





          {
            widths: "col-lg-12",
            tab:"outward",
            subComponents: [
              {
                inputType: "displaytext",
                widths: {
                  parent: "col-lg-2",
                  children: "col-lg-12"
                },
                label: "Subject",
                description: "Enter Subject"
              },
              {
                inputType: "autocomplete",
                isRequired: true,
    
                default: "",
                elementProps: {
                  stayOpen: false,
                  removeSelected: true,
                  disabled: false,
                  rtl: false
                },
                widths: {
                  parent: "col-lg-4",
                  children: "col-lg-12"
                },
                options: [],
                ajaxLoad: true,
                ajaxOptions: {
                  query: {
                    dialect: "mongodb",
                    query: "getOutwardSubjectEle",
                    fieldType: "string",
                    filters: ["pageData", "OutwardSubjectEle"]
                  },
                  label: "display",
                  value: "display"
                },
                 placeHolder: "Subject",
                name: "outwardSubject",
                description: "Enter Subject"
              },
              {
                inputType: "displaytext",
                // 
                widths: {
                  parent: "col-lg-2",
                  children: "col-lg-12"
                },
                label: "Date",
                description: "Enter Date"
              },
              {
                  inputType: "date",
                  dateType: "ontype",
                  
                  isRequired: true,
                  widths: {
                    parent: "col-lg-4",
                    children: "col-lg-12"
                  },
                  displayFormat: "DD/MM/YYYY",
                  outputFormat: "YYYYMMDD",
                  name: "dateoutward",
                  description: "Enter Date"
              },
              {
                inputType: "displaytext",
                // 
                widths: {
                  parent: "col-lg-2",
                  children: "col-lg-12"
                },
                label: "Message Number",
                description: "Enter Outward Message Number"
              },   
              {
                inputType: "numberonly",
                
                widths: {
                  parent: "col-lg-4",
                  children: "col-lg-12"
                },
                placeHolder: "Outward Message Number",
                name: "messagenumber",
                description: "Enter Outward Message Number"
              },
              {
                inputType: "displaytext",
                widths: {
                  parent: "col-lg-2",
                  children: "col-lg-12"
                },
                label: "Letter Template",
                description: "Enter Letter Template"
              },
              {
                inputType: "autocomplete",
                isRequired: true,
    
                default: "",
                elementProps: {
                  stayOpen: false,
                  removeSelected: true,
                  disabled: false,
                  rtl: false
                },
                widths: {
                  parent: "col-lg-4",
                  children: "col-lg-12"
                },
                options: [],
                ajaxLoad: true,
                ajaxOptions: {
                  query: {
                    dialect: "mongodb",
                    query: "getLetterTemplateEle",
                    fieldType: "string",
                    filters: ["pageData", "LetterTemplateEle"]
                  },
                  label: "display",
                  value: "display"
                },
                 placeHolder: "Letter Template",
                name: "LetterTemplate",
                description: "Enter Letter Template"
              },
              {
                inputType: "fileupload",
                widths: {
                  parent: "col-lg-6",
                  children: "col-lg-12"
                },
                label: "Attachment",
                name: "attachmentletter",
                placeholder: {
                  type: "text",
                  value:
                    "Attachment"
                },
                files: [],
                multiple: true
              },
              {
                inputType: "texteditor",
                // isRequired: true,
                // tab: "WYSIWYGEditor",
                widths: {
                  parent: "col-lg-10",
                  children: "col-lg-12"
                },
                // value:lastYearEnd(),
                placeHolder: "Tell a story..",
                label: "Myeditor",
                name: "Myeditor",
                description: "none",
                texteditor: "Mytexteditor"
              },

            ],
          },


          {
            widths: "col-lg-12",
            tab:"event",
            subComponents: [
              {
                inputType: "displaytext",
                // 
                widths: {
                  parent: "col-lg-2",
                  children: "col-lg-12"
                },
                label: "Title",
                description: "Enter Title"
              },   
              {
                inputType: "text",
                
                widths: {
                  parent: "col-lg-4",
                  children: "col-lg-12"
                },
                placeHolder: "Title",
                name: "title",
                description: "Enter Title"
              },
              {
                inputType: "displaytext",
                widths: {
                  parent: "col-lg-2",
                  children: "col-lg-12"
                },
                label: "Event Type",
                description: "Enter Event Type"
              },
              {
                inputType: "autocomplete",
                isRequired: true,
    
                default: "",
                elementProps: {
                  stayOpen: false,
                  removeSelected: true,
                  disabled: false,
                  rtl: false
                },
                widths: {
                  parent: "col-lg-4",
                  children: "col-lg-12"
                },
                options: [],
                ajaxLoad: true,
                ajaxOptions: {
                  query: {
                    dialect: "mongodb",
                    query: "getEventTypeEle",
                    fieldType: "string",
                    filters: ["pageData", "EventTypeEle"]
                  },
                  label: "display",
                  value: "display"
                },
                 placeHolder: "Event Type",
                name: "EventType",
                description: "Enter Event Type"
              },
              {
                inputType: "displaytext",
                // 
                widths: {
                  parent: "col-lg-2",
                  children: "col-lg-12"
                },
                label: "Start Date",
                description: "Enter Start Date"
              },
              {
                  inputType: "date",
                  dateType: "ontype",
                  
                  isRequired: true,
                  widths: {
                    parent: "col-lg-2",
                    children: "col-lg-12"
                  },
                  displayFormat: "DD/MM/YYYY",
                  outputFormat: "YYYYMMDD",
                  name: "startdate",
                  description: "Enter Start Date"
              },
              {
                inputType: "displaytext",
                // 
                widths: {
                  parent: "col-lg-2",
                  children: "col-lg-12"
                },
                label: "End Date",
                description: "Enter End Date"
              },
              {
                  inputType: "date",
                  dateType: "ontype",
                  
                  isRequired: true,
                  widths: {
                    parent: "col-lg-2",
                    children: "col-lg-12"
                  },
                  displayFormat: "DD/MM/YYYY",
                  outputFormat: "YYYYMMDD",
                  name: "enddate",
                  description: "Enter End Date"
              },
              {
                inputType: "displaytext",
                
                widths: {
                  parent: "col-lg-2",
                  children: "col-lg-12"
                },
                label: "Phone",
                description: "Enter Phone"
              },
              {
                inputType: "numberonly",
                
                widths: {
                  parent: "col-lg-2",
                  children: "col-lg-12"
                },
                placeHolder: "Phone",
                name: "phone",
                description: "Enter Phone"
              },
              {
                inputType: "displaytext",
                // 
                widths: {
                  parent: "col-lg-2",
                  children: "col-lg-12"
                },
                label: "Area",
                description: "Enter Area"
              },   
              {
                inputType: "text",
                
                widths: {
                  parent: "col-lg-4",
                  children: "col-lg-12"
                },
                placeHolder: "Area",
                name: "area",
                description: "Enter Area"
              },
              {
                inputType: "displaytext",
                // 
                widths: {
                  parent: "col-lg-2",
                  children: "col-lg-12"
                },
                label: "Venue",
                description: "Enter Venue"
              },   
              {
                inputType: "text",
                
                widths: {
                  parent: "col-lg-4",
                  children: "col-lg-12"
                },
                placeHolder: "Venue",
                name: "venue",
                description: "Enter Venue"
              },
              {
                inputType: "displaytext",
                // 
                widths: {
                  parent: "col-lg-2",
                  children: "col-lg-12"
                },
                label: "Description",
                description: "Enter Description"
              },   
              {
                inputType: "text",
                
                widths: {
                  parent: "col-lg-4",
                  children: "col-lg-12"
                },
                placeHolder: "Description",
                name: "descevent",
                description: "Enter Description"
              },
              {
                inputType: "fullCalender",
                widths: {
                  parent: "col-lg-12",
                  children: "col-lg-12"
                },
                label: "DatePicker",
                name: "DatePicker",
                description: "none",
                events: [
                  // {
                  //   id: 0,
                  //   title: "All Day Event very long title",
                  //   allDay: true,
                  //   start: new Date(2018, 7, 0),
                  //   end: new Date(2018, 7, 1)
                  // },
                  // {
                  //   id: 1,
                  //   title: "Long Event",
                  //   start: new Date(2018, 7, 7),
                  //   end: new Date(2018, 7, 10)
                  // },
          
                  // {
                  //   id: 2,
                  //   title: "DTS STARTS",
                  //   start: new Date(2019, 2, 13, 0, 0, 0),
                  //   end: new Date(2019, 2, 20, 0, 0, 0)
                  // },
          
                  // {
                  //   id: 3,
                  //   title: "DTS ENDS",
                  //   start: new Date(2019, 10, 6, 0, 0, 0),
                  //   end: new Date(2019, 10, 13, 0, 0, 0)
                  // },
          
                  // {
                  //   id: 4,
                  //   title: "Some Event",
                  //   start: new Date(2018, 7, 9, 0, 0, 0),
                  //   end: new Date(2018, 7, 10, 0, 0, 0)
                  // },
                  // {
                  //   id: 5,
                  //   title: "Conference",
                  //   start: new Date(2018, 7, 11),
                  //   end: new Date(2018, 7, 13),
                  //   desc: "Big conference for important people"
                  // },
                  // {
                  //   id: 6,
                  //   title: "Meeting",
                  //   start: new Date(2018, 7, 12, 10, 30, 0, 0),
                  //   end: new Date(2018, 7, 12, 12, 30, 0, 0),
                  //   desc: "Pre-meeting meeting, to prepare for the meeting"
                  // },
                  // {
                  //   id: 7,
                  //   title: "Lunch",
                  //   start: new Date(2018, 7, 12, 12, 0, 0, 0),
                  //   end: new Date(2018, 7, 12, 13, 0, 0, 0),
                  //   desc: "Power lunch"
                  // },
                  // {
                  //   id: 8,
                  //   title: "Meeting",
                  //   start: new Date(2018, 7, 12, 14, 0, 0, 0),
                  //   end: new Date(2018, 7, 12, 15, 0, 0, 0)
                  // },
                  // {
                  //   id: 9,
                  //   title: "Happy Hour",
                  //   start: new Date(2018, 7, 12, 17, 0, 0, 0),
                  //   end: new Date(2018, 7, 12, 17, 30, 0, 0),
                  //   desc: "Most important meal of the day"
                  // },
                  // {
                  //   id: 10,
                  //   title: "Dinner",
                  //   start: new Date(2018, 7, 12, 20, 0, 0, 0),
                  //   end: new Date(2018, 7, 12, 21, 0, 0, 0)
                  // },
                  // {
                  //   id: 11,
                  //   title: "Birthday Party",
                  //   start: new Date(2018, 7, 13, 7, 0, 0),
                  //   end: new Date(2018, 7, 13, 10, 30, 0)
                  // },
                  // {
                  //   id: 12,
                  //   title: "Late Night Event",
                  //   start: new Date(2018, 7, 17, 19, 30, 0),
                  //   end: new Date(2018, 7, 18, 2, 0, 0)
                  // },
                  // {
                  //   id: 12.5,
                  //   title: "Late Same Night Event",
                  //   start: new Date(2018, 7, 17, 19, 30, 0),
                  //   end: new Date(2018, 7, 17, 23, 30, 0)
                  // },
                  // {
                  //   id: 13,
                  //   title: "Multi-day Event",
                  //   start: new Date(2018, 7, 20, 19, 30, 0),
                  //   end: new Date(2018, 7, 22, 2, 0, 0)
                  // },
                  // {
                  //   id: 14,
                  //   title: "Today",
                  //   start: new Date(new Date().setHours(new Date().getHours() - 3)),
                  //   end: new Date(new Date().setHours(new Date().getHours() + 3))
                  // }
                ]
              },
              
            ],
          },



          {
            widths: "col-lg-12",
            tab:"relations",
            subComponents: [
              {
                inputType: "text",
                widths: {
                  parent: "col-lg-2",
                  children: "col-lg-12"
                },
                name: "City",
                description: "Enter City"
              },

            ],
          },


          {
            widths: "col-lg-12",
            tab:"family",
            subComponents: [
              {
                inputType: "displaytext",
                widths: {
                  parent: "col-lg-2",
                  children: "col-lg-12"
                },
                label: "Father",
                description: "Enter Father"
              },
              {
                inputType: "autocomplete",
                isRequired: true,
    
                default: "",
                elementProps: {
                  stayOpen: false,
                  removeSelected: true,
                  disabled: false,
                  rtl: false
                },
                widths: {
                  parent: "col-lg-4",
                  children: "col-lg-12"
                },
                options: [],
                ajaxLoad: true,
                ajaxOptions: {
                  query: {
                    dialect: "mongodb",
                    query: "getVoterID",
                    fieldType: "string",
                    filters: ["pageData", "VoterID"]
                  },
                  label: "display",
                  value: "display"
                },
                 placeHolder: "Father",
                name: "father",
                description: "Enter Father"
              },
              {
                inputType: "displaytext",
                widths: {
                  parent: "col-lg-2",
                  children: "col-lg-12"
                },
                label: "Mother",
                description: "Enter Mother"
              },
              {
                inputType: "autocomplete",
                isRequired: true,
    
                default: "",
                elementProps: {
                  stayOpen: false,
                  removeSelected: true,
                  disabled: false,
                  rtl: false
                },
                widths: {
                  parent: "col-lg-4",
                  children: "col-lg-12"
                },
                options: [],
                ajaxLoad: true,
                ajaxOptions: {
                  query: {
                    dialect: "mongodb",
                    query: "getVoterID",
                    fieldType: "string",
                    filters: ["pageData", "VoterID"]
                  },
                  label: "display",
                  value: "display"
                },
                 placeHolder: "Mother",
                name: "mother",
                description: "Enter Mother"
              },
              {
                inputType: "displaytext",
                widths: {
                  parent: "col-lg-2",
                  children: "col-lg-12"
                },
                label: "Sister",
                description: "Enter Sister"
              },
              {
                inputType: "autocomplete",
                isRequired: true,
    
                default: "",
                elementProps: {
                  stayOpen: false,
                  removeSelected: true,
                  disabled: false,
                  rtl: false
                },
                widths: {
                  parent: "col-lg-4",
                  children: "col-lg-12"
                },
                options: [],
                ajaxLoad: true,
                ajaxOptions: {
                  query: {
                    dialect: "mongodb",
                    query: "getVoterID",
                    fieldType: "string",
                    filters: ["pageData", "VoterID"]
                  },
                  label: "display",
                  value: "display"
                },
                 placeHolder: "Sister",
                name: "sister",
                description: "Enter Sister"
              },
              {
                inputType: "displaytext",
                widths: {
                  parent: "col-lg-2",
                  children: "col-lg-12"
                },
                label: "Brother",
                description: "Enter Brother"
              },
              {
                inputType: "autocomplete",
                isRequired: true,
    
                default: "",
                elementProps: {
                  stayOpen: false,
                  removeSelected: true,
                  disabled: false,
                  rtl: false
                },
                widths: {
                  parent: "col-lg-4",
                  children: "col-lg-12"
                },
                options: [],
                ajaxLoad: true,
                ajaxOptions: {
                  query: {
                    dialect: "mongodb",
                    query: "getVoterID",
                    fieldType: "string",
                    filters: ["pageData", "VoterID"]
                  },
                  label: "display",
                  value: "display"
                },
                 placeHolder: "Brother",
                name: "brother",
                description: "Enter Brother"
              },
              {
                inputType: "displaytext",
                widths: {
                  parent: "col-lg-2",
                  children: "col-lg-12"
                },
                label: "Son",
                description: "Enter Son"
              },
              {
                inputType: "autocomplete",
                isRequired: true,
    
                default: "",
                elementProps: {
                  stayOpen: false,
                  removeSelected: true,
                  disabled: false,
                  rtl: false
                },
                widths: {
                  parent: "col-lg-4",
                  children: "col-lg-12"
                },
                options: [],
                ajaxLoad: true,
                ajaxOptions: {
                  query: {
                    dialect: "mongodb",
                    query: "getVoterID",
                    fieldType: "string",
                    filters: ["pageData", "VoterID"]
                  },
                  label: "display",
                  value: "display"
                },
                 placeHolder: "Son",
                name: "son",
                description: "Enter Son"
              },
              {
                inputType: "displaytext",
                widths: {
                  parent: "col-lg-2",
                  children: "col-lg-12"
                },
                label: "Daughter",
                description: "Enter Daughter"
              },
              {
                inputType: "autocomplete",
                isRequired: true,
    
                default: "",
                elementProps: {
                  stayOpen: false,
                  removeSelected: true,
                  disabled: false,
                  rtl: false
                },
                widths: {
                  parent: "col-lg-4",
                  children: "col-lg-12"
                },
                options: [],
                ajaxLoad: true,
                ajaxOptions: {
                  query: {
                    dialect: "mongodb",
                    query: "getVoterID",
                    fieldType: "string",
                    filters: ["pageData", "VoterID"]
                  },
                  label: "display",
                  value: "display"
                },
                 placeHolder: "Daughter",
                name: "daughter",
                description: "Enter Daughter"
              },
              {
                inputType: "displaytext",
                widths: {
                  parent: "col-lg-2",
                  children: "col-lg-12"
                },
                label: "Wife",
                description: "Enter Wife"
              },
              {
                inputType: "autocomplete",
                isRequired: true,
    
                default: "",
                elementProps: {
                  stayOpen: false,
                  removeSelected: true,
                  disabled: false,
                  rtl: false
                },
                widths: {
                  parent: "col-lg-4",
                  children: "col-lg-12"
                },
                options: [],
                ajaxLoad: true,
                ajaxOptions: {
                  query: {
                    dialect: "mongodb",
                    query: "getVoterID",
                    fieldType: "string",
                    filters: ["pageData", "VoterID"]
                  },
                  label: "display",
                  value: "display"
                },
                 placeHolder: "Wife",
                name: "wife",
                description: "Enter Wife"
              },
              {
                inputType: "displaytext",
                widths: {
                  parent: "col-lg-2",
                  children: "col-lg-12"
                },
                label: "Husband",
                description: "Enter Husband"
              },
              {
                inputType: "autocomplete",
                isRequired: true,
    
                default: "",
                elementProps: {
                  stayOpen: false,
                  removeSelected: true,
                  disabled: false,
                  rtl: false
                },
                widths: {
                  parent: "col-lg-4",
                  children: "col-lg-12"
                },
                options: [],
                ajaxLoad: true,
                ajaxOptions: {
                  query: {
                    dialect: "mongodb",
                    query: "getVoterID",
                    fieldType: "string",
                    filters: ["pageData", "VoterID"]
                  },
                  label: "display",
                  value: "display"
                },
                 placeHolder: "Husband",
                name: "husband",
                description: "Enter Husband"
              },
              {
                inputType: "displaytext",
                widths: {
                  parent: "col-lg-2",
                  children: "col-lg-12"
                },
                label: "Uncle",
                description: "Enter Uncle"
              },
              {
                inputType: "autocomplete",
                isRequired: true,
    
                default: "",
                elementProps: {
                  stayOpen: false,
                  removeSelected: true,
                  disabled: false,
                  rtl: false
                },
                widths: {
                  parent: "col-lg-4",
                  children: "col-lg-12"
                },
                options: [],
                ajaxLoad: true,
                ajaxOptions: {
                  query: {
                    dialect: "mongodb",
                    query: "getVoterID",
                    fieldType: "string",
                    filters: ["pageData", "VoterID"]
                  },
                  label: "display",
                  value: "display"
                },
                 placeHolder: "Uncle",
                name: "uncle",
                description: "Enter Uncle"
              },
              {
                inputType: "displaytext",
                widths: {
                  parent: "col-lg-2",
                  children: "col-lg-12"
                },
                label: "Aunty",
                description: "Enter Aunty"
              },
              {
                inputType: "autocomplete",
                isRequired: true,
    
                default: "",
                elementProps: {
                  stayOpen: false,
                  removeSelected: true,
                  disabled: false,
                  rtl: false
                },
                widths: {
                  parent: "col-lg-4",
                  children: "col-lg-12"
                },
                options: [],
                ajaxLoad: true,
                ajaxOptions: {
                  query: {
                    dialect: "mongodb",
                    query: "getVoterID",
                    fieldType: "string",
                    filters: ["pageData", "VoterID"]
                  },
                  label: "display",
                  value: "display"
                },
                 placeHolder: "Aunty",
                name: "aunty",
                description: "Enter Aunty"
              },

            ],
          },
        ],

           
        
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
          history: {
            perPage: 10,
            // reportHeader: "User Statement",
            pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
            displayColumns: [
              {
                Header: "Voter ID",
                accessor: "VoterID",
                // width: 150,
              },
              {
                Header: "First Name",
                accessor: "firstName",
                
              },
              {
                Header: "Middle Name",
                accessor: "middleName"
              },
              {
                Header: "Last Name",
                accessor: "lastName",
                
              },
              {
                Header: "Sub Circle",
                accessor: "subCircle"
              },
              {
                Header: "Booth",
                accessor: "booth"
              }
            ]
          },
          report: {
            perPage: 10,
            queryType: "mysqlQuery",
            //   groupBy: ["schedule","subschedule"],
            query: [
              {
                dialect: "mysql",
                seq: 1,
                columnHeader: [
                  {
                    id: "balance1",
                    headerText: "trdate",
                    headerFrom: "balance"
                  }
                ],
                query: ""
              }
            ],
            displayColumns: [
              {
                Header: "Voter ID",
                accessor: "VoterID",
                // width: 150,
              },
              {
                Header: "First Name",
                accessor: "firstName",
                
              },
              {
                Header: "Middle Name",
                accessor: "middleName"
              },
              {
                Header: "Last Name",
                accessor: "lastName",
                
              },
              {
                Header: "Sub Circle",
                accessor: "subCircle"
              },
              {
                Header: "Booth",
                accessor: "booth"
              }
              
            ]
          }
          
    
  };
export default nonvoter